module.exports = __webpack_public_path__ + "media/1.0a00903b.mp3";